<template>
  <div>
    <v-card>
      <v-card-title>
      <v-icon color="primary">
        mdi-ticket-percent
      </v-icon>
        <span class="px-2">{{$t('Coupons')}}</span>
        <v-spacer></v-spacer>
        <create-button @create="showCouponDialog"></create-button>
        <activation-tool-tip model="coupons"></activation-tool-tip>
      </v-card-title>
        <v-data-table
        :no-data-text="$t('noData')"
        :no-results-text="$t('noResults')"
        item-key="id"
        :loading="isLoading"
        :loading-text="$t('loading_text')"
        :headers="translatedHeaders"
        :items="coupons"
        :search="search"
        :footer-props="footerProps"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('search')"
            class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:item.driver="{ item }">
          <v-chip :color="getDriverAssignmentColor(item.driver)" dark @click="assignDriver(item)">
            {{ getDriver(item.driver) }}
          </v-chip>
        </template>
        <template v-slot:item.discount="{ item }">
            {{ item.discount }}%
        </template>
        <template v-slot:item.limit="{ item }">
            {{ item.limit == 0 ? $t('unlimited') : item.limit }}
        </template>
        <template v-slot:item.max_amount="{ item }">
            {{ item.max_amount == 0 ? $t('unlimited') : item.max_amount }}
        </template>
        <template v-slot:item.expiration_date="{ item }">
          <small>{{ item.expiration_date | moment("LL") }}</small>
        </template>
        <template v-slot:item.created_at="{ item }">
          <small>{{ item.created_at | moment("LL") }}</small> -
          <small class="text-muted">{{ item.created_at | moment("LT") }}</small>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mx-2"
            @click="editCoupon(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
          class="mx-2"
            small
            @click="deleteCoupon(item, coupons.indexOf(item))"
          >
            mdi-delete
          </v-icon>
          <v-icon
          class="mx-2"
            small
            @click="sendNotification(item)"
            >
            mdi-bell
            </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog
        v-model="couponDialog"
        persistent
        max-width="900px"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{$t('coupon_data')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="code"
                      :rules="codeRules"
                      :label="$t('coupon_code') + '*'"
                      :hint="$t('coupon_code_hint')"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="discount"
                      :rules="discountRules"
                      :label="$t('coupon_discount') + '*'"
                      :hint="$t('coupon_discount_hint')"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="limit"
                      :rules="limitRules"
                      :label="$t('coupon_limit') + '*'"
                      :hint="$t('coupon_limit_hint')"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="max_amount"
                      :rules="max_amountRules"
                      :label="$t('coupon_max_amount') + '*'"
                      :hint="$t('coupon_max_amount_hint')"
                      required
                    ></v-text-field>
                  </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="4"
                    >
                        <v-menu
                            ref="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="expiration_date"
                                    :rules="expiration_dateRules"
                                    :label="$t('coupon_expiration_date') + '*'"
                                    :hint="$t('coupon_expiration_date_hint')"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="expiration_date"
                                no-title
                                scrollable
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="couponDialog = false"
              >
                {{$t('cancel')}}
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="createCoupon"
              >
                {{$t('Save Changes')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import ActivationToolTip from "@/components/ActivationToolTip";
import CreateButton from "@/components/CreateButton";
import auth from '@/services/AuthService'
export default {
  components: {
    ActivationToolTip,
    CreateButton,
  },
  data() {
    return {
      coupons: [],
      isLoading: false,
      search: "",
      couponDialog: false,
      valid: true,
      id: null,
      code: '',
      codeRules: [
        v => !!v || this.$t('coupon_code_required'),
        v => (v && v.length <= 15) || this.$t('coupon_code_max_length'),
      ],
      limit: '1',
      limitRules: [
        v => /^[0-9]+$/.test(v) || this.$t('coupon_limit_required'),
      ],
      discount: '10',
      discountRules: [
        v => /^[0-9]+$/.test(v) || this.$t('coupon_discount_required'),
      ],
      max_amount: '1',
      max_amountRules:
      [
        v => /^[0-9]+$/.test(v) || this.$t('coupon_max_amount_required'),
      ],
      expiration_date: '',
      expiration_dateRules: [
        v => !!v || this.$t('coupon_expiration_date_required'),
      ],
      headers: [
        { text: "id", value: "id", align: "start", filterable: false },
        { text: "coupon_code", value: "code" },
        { text: "coupon_discount", value: "discount"},
        { text: "coupon_usage_limit", value: "limit" },
        { text: "coupon_max_saving", value: "max_amount" },
        { text: "coupon_expiration", value: "expiration_date" },
        { text: "created_at", value: "created_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    translatedHeaders() {
      return this.headers.map(header => ({
        ...header,
        text: this.$t(header.text)
      }));
    },
    footerProps() {
      return {
        itemsPerPageText: this.$t("rows_per_page"),
      }
    }
  },
  mounted() {
    this.loadCoupones();
  },
  methods: {
    loadCoupones() {
      this.isLoading = true;
      this.coupons = [];
      axios
        .get(`/coupons/all`)
        .then((response) => {
          this.coupons = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: this.$t("Error"),
            text: this.$t("coupon_error_retrieving"),
            type: 'error'
          });
          console.log(error);
          auth.checkError(error.response.data.message, this.$router, this.$swal);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    validate () {
      return this.$refs.form.validate()
    },
    createCoupon() {
      if(this.validate())
      {
        this.isLoading = true;
        this.couponDialog = false;
        axios
          .post(`/coupons/create-edit`, {
            coupon: {
              id: this.id,
                code: this.code,
                discount: this.discount,
                limit: this.limit,
                max_amount: this.max_amount,
                expiration_date: this.expiration_date,
            },
          })
          .then((response) => {
            this.loadCoupones();
            this.$notify({
              title: this.$t("Success"),
              text: this.id? this.$t("coupon_updated") : this.$t("coupon_created"),
              type: 'success'
            });
            let msg = '';
            if(this.id)
            {
                msg = this.$t("coupon_updated_successfully");
            }
            else
            {
                msg = this.$t("coupon_created_successfully");
            }
            this.$swal("Success", msg, "success");
          })
          .catch((error) => {
            this.$notify({
              title: this.$t("Error"),
              text: this.$t("coupon_error_creating"),
              type: 'error'
            });
            console.log(error);
            this.$swal(this.$t("Error"), error.response.data.message, "error");
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
    showCouponDialog() {
      this.code = '';
      this.limit = '1';
      this.max_amount = '1';
      this.discount = '10';
      this.expiration_date = new Date().toISOString().substr(0, 10);
      this.id = null;
      this.couponDialog = true;
    },
    editCoupon(coupon) {
      this.id = coupon.id;
      this.code = coupon.code;
      this.discount = coupon.discount;
      this.limit = coupon.limit;
      this.max_amount = coupon.max_amount;
      this.expiration_date = coupon.expiration_date;
      this.couponDialog = true;
    },
    deleteCoupon(coupon, index) {
      this.$swal
        .fire({
          title: this.$t("coupon_delete_title"),
          text: this.$t("coupon_delete_text", { code: coupon.code }),
          icon: "error",
          showCancelButton: true,
          confirmButtonText: this.$t("yes_delete"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteCouponServer(coupon.id, index);
          }
        });
    },
    deleteCouponServer(coupon_id, index) {
      axios
        .delete(`/coupons/${coupon_id}`)
        .then((response) => {
          this.coupons.splice(index, 1);
          this.$notify({
            title: this.$t("Success"),
            text: this.$t("coupon_deleted"),
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            title: this.$t("Error"),
            text: this.$t("coupon_error_deleting"),
            type: 'error'
          });
          this.$swal(this.$t("Error"), error.response.data.message, "error");
        })
        .then(() => {
          //this.isDeleting = false;
        });
    },
    sendNotification(coupon){
      //format date
      let expiration_date = new Date(coupon.expiration_date).toLocaleDateString( "en-US", { year: 'numeric', month: 'long', day: 'numeric' });
      let notification_message = this.$t('coupon_default_notification', { code: coupon.code, discount: coupon.discount, expiration_date: expiration_date });
      if(coupon.limit > 0)
        notification_message += this.$t('coupon_limited_notification', { limit: coupon.limit });
        //show swal with textarea
        this.$swal({
            input: 'textarea',
            inputPlaceholder: this.$t('coupon_send_notification_placeholder'),
            inputAttributes: {
            'aria-label': this.$t('coupon_send_notification_placeholder')
            },
            title: this.$t('coupon_send_notification_title'),
            html: this.$t('coupon_send_notification_placeholder'),
            icon: "info",
            showCancelButton: true,
            confirmButtonText: this.$t('coupon_send_notification_button'),
            cancelButtonText: this.$t('cancel'),
            //form input based on coupon data
            inputValue: notification_message
        }).then((result) => {
            if (result.isConfirmed) {
            axios
                .post(`/coupons/notify`, {
                id: coupon.id,
                message: result.value,
                })
                .then((response) => {
                this.$notify({
                    title: this.$t("Success"),
                    text: this.$t("coupon_notification_sent"),
                    type: "success",
                });
                if(response.status == 201)
                    this.$swal("Info", response.data.message, "info");
                })
                .catch((error) => {
                this.$notify({
                    title: this.$t("Error"),
                    text: this.$t("coupon_error_sending_notification"),
                    type: "error",
                });
                console.log(error);
                this.$swal(this.$t("Error"), error.response.data.message, "error");
                });
            }
        });
    },
  },
};
</script>
